import { css } from '@emotion/react';
import { Button } from '@opendoor/bricks/core';
import { novo } from '@opendoor/bricks/theme';

import { IBNComponentThemeConfig } from '../styles/ComponentTheme';
import { FooterForegroundBox } from './Footer';

const buttonCSS = css`
  border-radius: ${novo.radii.roundedSquare};
`;

const FooterHelpCenter = ({
  theme,
  helpCenterLink,
}: {
  theme: IBNComponentThemeConfig;
  helpCenterLink?: string;
}) => (
  <FooterForegroundBox theme={theme} title="Still have questions?">
    {/* @ts-expect-error onClick not needed for anchor links */}
    <Button
      type="button"
      as="a"
      href={helpCenterLink}
      aria-label="Opendoor Help Center button"
      analyticsName="cosmos-landing-page-v2-footer-help-center"
      bg="warmgrey950"
      color="white0"
      _hover={{ backgroundColor: 'warmgrey800', color: 'white0' }}
      _active={{ backgroundColor: 'warmgrey800', color: 'white0' }}
      alignItems="center"
      display="inline-flex"
      fontSize="14px"
      letterSpacing="-1.4"
      pb="8px"
      pt="8px"
      minHeight="45px"
      maxHeight="45px"
      textAlign="center"
      width="fit-content"
      css={buttonCSS}
    >
      Visit the Help Center
    </Button>
  </FooterForegroundBox>
);

export default FooterHelpCenter;
